import React from 'react';

export default function Submissions(props) {
    // let sub_open = 'The submission portal is now open:';
    let sub1 = 'We are soliciting short presentation proposals (1 page using the SOUPS formatting template, found '
    let sub2 = ') for 15-minute talks related to privacy attacks, threats, and threat modeling. These may take the form of:'
    let subList = ['Positions, arguments, or perspectives',
                    'Proposals of processes, methodologies, or solutions',
                    'Novel ideas',
                    'Previously published results',
                    'Works in progress',
                    'Case studies']
    let sub3 = 'Submissions should include author names and affiliations. Workshop presentation abstracts and slide decks will be posted to ';
    let sub4 = ' and '
    let sub5 = ' following the workshop. These submissions will not be considered “published” work and should not preclude publication or presentation elsewhere.'
    let sub6 = 'Please email ';
    let sub7 = ' with questions.';
    let reg1 ='Registration is required for workshop attendance! Please see ';
    let reg2 = ' for more information when available.';
    let sub_close = 'The submission portal opens Thursday, May 1, 2025.'
    
    return (
        <div className='base-page'>
            <div className='submission-details'>
                <h4 className='heading'>Submissions</h4>

                <p><b>
                    {reg1}
                    <a className='link' href='/#/attending'>Attending</a>
                    {reg2}
                </b></p>

                <hr style={{marginTop:'25px', marginBottom:'25px'}}></hr>

                {/* Submission info */}
                <p><b>{sub_close}</b></p>

                <p> {sub1}
                <a className='link' href='https://www.usenix.org/conference/soups2025/call-for-papers' target='_blank' rel="noopener noreferrer">here</a>
                {sub2}
                </p>
                <ul className='bulleted-list'>
                {subList.map((subType, index) => (
                    <li>{subType}</li>
                ))}
                </ul>
                <p>{sub3}
                <a className='link' href='/#/proceedings'>Proceedings</a>
                {sub4}
                <a className='link' href='/#/program'>Program</a>
                {sub5}
                </p>

                {<ul style={{paddingLeft:'0px'}}>
                    <li style={{display:'inline-block'}}>
                        <button className='submit' onClick={()=> window.open("https://wptm2025.usenix.hotcrp.com/", "_blank", "noopener, noreferrer")}>
                            Submit Proposal
                        </button>
                    </li>
                </ul>}

                <p>{sub6}
                <a className='link' href='mailto:PTMworkshop@mitre.org'>PTMworkshop@mitre.org</a>
                {sub7}
                </p>
            </div>
            <div className='new-section'>
                <h4 className='heading'>Program Committee</h4>
                <p>Cara Bloom, Netflix</p>
                <p>Jason Cronk, EnterPrivacy</p>
                <p>Stuart Shapiro, MITRE</p>
                <p>Laurens Sion, KU Leuven</p>
                <p>Kim Wuyts, PWC Belgium</p>
                
            </div>
            <div className='new-section'>
            <h4 className='heading'>Important Dates</h4>
                <p>Wednesday, May 1, 2025 – Submissions open for presentation proposals</p>
                <p>Thursday, May 22, 2025 23:59 AOE – Submission deadline</p>
                <p>Thursday, June 5, 2025 – Decisions announced</p>
                <p>Sunday, August 10, 2025 – The 4<sup>th</sup> Workshop on Privacy Threat Modeling</p>
            </div>
        </div>
    )
}
                // Insert after line 52 for submit button
                /*{<ul style={{paddingLeft:'0px'}}>
                    <li style={{display:'inline-block'}}>
                        <button className='submit' onClick={()=> window.open("https://wptm2025.usenix.hotcrp.com/", "_blank", "noopener, noreferrer")}>
                            Submit Proposal
                        </button>
                    </li>
                </ul>}*/